"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHIP_COLORS = void 0;
exports.CHIP_COLORS = [
    'primary',
    'cyan',
    'fuchsia',
    'green',
    'orange',
    'pink',
    'purple',
    'red',
    'skyBlue',
    'teal',
    'violet',
    'yellow',
    'random',
    'default',
];
